import moment from 'moment';

/**
 * Định dạng ngày tháng dựa trên giá trị đầu vào và định dạng cho trước.
 * 
 * @param {number | Date | string} value - Giá trị của ngày tháng, có thể là số, đối tượng Date, hoặc chuỗi.
 * @param {string} [format='YYYY-MM-DD'] - Định dạng mong muốn, mặc định là 'YYYY-MM-DD'.
 * @returns {string} - Chuỗi ngày tháng đã được định dạng.
 */
export const formatDate = (value, format = 'YYYY-MM-DD') => {
  return moment(value).format(format);
};